import { cancelBackgroundResolvePriming } from '../read/cancel-background-resolve-priming.js';
import {
  decrementInFlightReads,
  decrementInFlightRequests,
  incrementInFlightReads,
  incrementInFlightRequests,
} from './counts.js';
import {
  notifyFileBrowserActivity,
  notifyFileBrowserReadStart,
  notifyFileBrowserRequestStart,
} from './listeners.js';
import { publishAfterActivityChange } from './publish.js';

function beginFileBrowserActivity(
  kind: 'request' | 'read',
  notifyStart: () => void,
): void {
  if (kind === 'request') {
    incrementInFlightRequests();
  } else {
    incrementInFlightReads();
    cancelBackgroundResolvePriming();
  }
  publishAfterActivityChange();
  notifyStart();
  notifyFileBrowserActivity();
}

function endFileBrowserActivity(kind: 'request' | 'read'): void {
  if (kind === 'request') {
    decrementInFlightRequests();
  } else {
    decrementInFlightReads();
  }
  publishAfterActivityChange();
}

export function beginFileBrowserRequest(): void {
  beginFileBrowserActivity('request', notifyFileBrowserRequestStart);
}

export function endFileBrowserRequest(): void {
  endFileBrowserActivity('request');
}

export function beginFileBrowserRead(): void {
  beginFileBrowserActivity('read', notifyFileBrowserReadStart);
}

export function endFileBrowserRead(): void {
  endFileBrowserActivity('read');
}
